var RfpType;
(function (RfpType) {
    RfpType["Classic"] = "Classic";
    RfpType["RaiseHand"] = "RaiseHand";
})(RfpType || (RfpType = {}));
export default RfpType;
